
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exchange/[permalink]",
      function () {
        return require("private-next-pages/exchange/[permalink].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exchange/[permalink]"])
      });
    }
  